"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.034 2.263a23.042 23.042 0 0 0-5.457-.176c-.54.05-1.025.41-1.157.962-.053.223-.099.48-.113.741-.013.26.021.504.072.714.138.566.682.845 1.196.855l1.169.021a81.253 81.253 0 0 0-3.58 4.01c-.398.48-.507 1.16-.059 1.676a8.384 8.384 0 0 0 .836.834c.515.445 1.185.332 1.658-.068a99.578 99.578 0 0 0 4.003-3.588l.022 1.182c.01.513.287 1.056.852 1.194.209.052.453.086.712.073.26-.014.517-.06.738-.114.552-.132.909-.617.962-1.154.194-1.982.125-4.066-.12-5.502-.153-.888-.862-1.521-1.734-1.66ZM9.423 21.913c-1.98.183-4.014.054-5.457-.176-.872-.139-1.581-.772-1.733-1.66-.246-1.436-.315-3.52-.12-5.502.052-.537.409-1.022.96-1.154.222-.054.478-.1.739-.114.259-.013.503.021.712.073.565.138.842.681.852 1.193l.021 1.182a100.572 100.572 0 0 1 4.004-3.587c.473-.4 1.143-.513 1.658-.068a8.38 8.38 0 0 1 .835.834c.449.517.34 1.196-.059 1.676a81.8 81.8 0 0 1-3.579 4.01l1.169.021c.514.01 1.058.289 1.196.855.05.21.085.455.072.714-.014.261-.06.518-.113.74-.132.553-.617.913-1.157.963Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgExpand);
var _default = exports["default"] = Memo;